import styled from 'styled-components/macro'

import { colors } from '../../../Global/Styles/variables'

interface ModalProps {
  autoFocus: boolean
  styles?: string
}

export const Layer = styled.div<{
  styles?: string
}>`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(62, 70, 86, 0.5);
  top: 0;
  left: 0;
  z-index: 5;
  overflow: auto;

  ${({ styles }) => styles};
`

export const Modal = styled.div<ModalProps>`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  width: 100%;
  max-width: max-content;
  background-color: ${colors.white};
  padding: 2rem;
  box-shadow: 5px 5px 0.625rem rgba(224, 199, 158, 0.24);
  border-radius: 1rem;
  max-height: 100%;
  overflow-y: auto;

  ${({ styles }) => styles};
`
